module.exports = __webpack_public_path__ + "img/ice.f82b7e5d.svg";